module.exports = __webpack_public_path__ + "img/img-12.79fd737c.png";